import type { PackageManager } from '@cli-types/core-engine/utils.js'
import { execFileAsync } from './exec-file-async.js'

export async function runPmScript(
  pm: PackageManager,
  script: string,
  cwd: string,
  timeout?: number
): Promise<boolean> {
  const args = pm === 'bun' ? ['run', script] : [script]
  try {
    await execFileAsync(pm, args, { cwd, timeout })
    return true
  } catch {
    return false
  }
}
